// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__fhMRP","label":"styles_label__SvHL1","icon":"styles_icon___vVHI"};